import { ComponentPropsWithoutRef } from 'react'

import styles from './Loading.module.css'

interface Props extends ComponentPropsWithoutRef<'div'> {}

export function Loading(props: Props) {
  return (
    <div {...props}>
      <div className={styles.container}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>
    </div>
  )
}
